module.exports = __webpack_public_path__ + "img/notification.28d58f6b.svg";